<template>
	<div>
	<div class="row">
		<div class="col-md-4 col-12 form-group" v-if="!visualizar">
			<div class="input-group">
				<input class="form-control form-control-sm"
						v-model="mpn"
						@keyup="mpn = $event.target.value.toUpperCase()">

				<span class="input-group-append">
					<button class="btn btn-sm btn-outline-primary" type="button"
							:disabled="mpn.trim() == ''"
							@click="adicionarMpnInspecao(); mpn = ''">
					<fa-icon icon="plus"></fa-icon> ADICIONAR</button>
				</span>
			</div>
		</div>

		<div class="col-12 col-md-8" style="margin-bottom: 30px">
			<span v-for="(item, index) in mpnInspecao" :key="index">
				<div class="badges badge-primary badge-pn"  v-if="!item.excluir" >
					{{item.descricao}}
					<span v-if="!visualizar" class="float-right" style="cursor:pointer;margin-left:10px"
						@click="excluirMpnInspecao(index)">
						<fa-icon icon="times" title="Clique para remover"></fa-icon>
					</span>
				</div>
			</span>
		</div>
	</div>
</div>
</template>

<script>
export default {
	props:['mpnInspecao', 'visualizar'],

	data () {
		return {
			mpn: '',
			form: {
				mpnInspecao: this.mpnInspecao
			}

		}
	},

	methods: {
		excluirMpnInspecao(index) {
			if (this.form.mpnInspecao[index].id != 0) {
				this.form.mpnInspecao[index].excluir = true;
			} else {
				this.form.mpnInspecao.splice(index, 1);
			}
		},

		adicionarMpnInspecao() {
			this.form.mpnInspecao.push({
				id: 0,
				descricao: this.mpn,
				excluir: false,
			})
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/views/followair/manutencao/cadastro/inspecao/components/mpn.vue